module.exports = __webpack_public_path__ + "img/chest-frame.9f4c5c1c.png";